import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminLayout from "../Admin/components/AdminLayout";
import Dashboard from "../Admin/pages/Dashboard";
import { Table } from "../Admin/pages/Table";
import ClientList from "../Admin/pages/ClientList";
import PartnerRequest from "../Admin/pages/PartnerRequest";
import ChangePassword from "../Admin/pages/ChangePassword";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminLayout />}>

        {/* Default Dashboard */}
        <Route index element={<Dashboard />} />

        {/*  Dashboard Route */}
        <Route path="dashboard" element={<Dashboard />} />

        <Route path="change-password" element={< ChangePassword />} />

        {/*Table Routes */}
        <Route path="table" element={<Table />}>
          <Route path="clients" element={<ClientList />} />
          <Route path="partners" element={<PartnerRequest />} />

        </Route>

      </Route>
    </Routes>
  );
};

export default AdminRoutes;